/**
 * @module estrutura/commands/estruturacommand
 */

import { Command } from 'ckeditor5/src/core';
import {
	Dispositivo,
	Estrutura
} from '../models';

const ESTRUTURA = 'estrutura';

/**
 * The insert estrutura command.
 *
 * The command is registered by {@link module:estrutura/estruturaediting~EstruturaEditing} as `'estrutura'` editor command.
 *
 * To insert a estrutura at the current selection, execute the command and specify the type:
 *
 *		editor.execute( 'estrutura', { type: 1 } );
 *
 * @extends {Command}
 */
export default class EstruturaCommand extends Command {

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );
		this._config = editor.config.get( ESTRUTURA ) || {};

		/**
		 * @type {Map<number, Dispositivo>}
		 */
		this._dispositivos = new Map();
		if ( this._config.dispositivos ) {
			for ( const disp of this._config.dispositivos ) {
				this._dispositivos.set( disp.codigo, disp );
			}
		}
	}

	/**
	 * Executes the command.
	 *
	 * Inserts a estrutura with the specified dispositivo.
	 *
	 * @param {Object} options
	 * @param {number} [options.dispositivo=null] The dispositivo code to be used estrutura.
	 */
	execute( options = {} ) {
		const data = this.editor.data;
		const model = this.editor.model;
		const selection = model.document.selection;

		if ( !selection.isCollapsed ) {
			return;
		}

		if ( options == null ) {
			options = {};
		}

		const dispType = options.dispositivo;
		const dispositivo = this._dispositivos.get( dispType );

		if ( dispositivo == null ) {
			console.error( "Tentando inserir dispositivo de numero %d nao encontrado.", dispType );
			return;
		}

		const range = selection.getFirstRange();
		const selectedEstrutura = range.root.getNodeByPath( range.start.path.slice( 0, 1 ) );
		const posBefore = model.createPositionBefore( selectedEstrutura );
		const posAfter = model.createPositionAfter( selectedEstrutura );
		const position = ( range.start.isTouching( posBefore ) && !range.start.isTouching( posAfter ) ) ? posBefore : posAfter;

		model.change( writer => {
			const estrutura = new Estrutura( dispType );
			const newDisp = writer.createElement( ESTRUTURA, {
				estrutura
			} );

			if ( dispositivo && dispositivo.estilo ) {
				const viewFragment = data.processor.toView( dispositivo.estilo );
				const modelFragment = data.toModel( viewFragment, '$clipboardHolder' );
				writer.append( modelFragment, newDisp );
			}

			writer.insert( newDisp, position );

			writer.setSelection( newDisp, 'end' );
		} );
	}
}
